<div fxLayout="column">
<!--    <div fxLayout="row" fxFlex="grow" fxLayoutAlign="start center center" class="modal-header">-->
<!--        <span fxFlex="grow" class="modal-title">Τα μηνύματά μου</span>-->
<!--        <mat-icon (click)="close()" class="modal-close">close</mat-icon>-->
<!--    </div>-->

    <div fxLayout="row" fxLayoutAlign="start center center" fxLayoutGap="5px" fxFlex="grow">
        <div>Αναζήτηση</div>
        <div>
            <mat-form-field>
                <label>
                    <input matInput (keydown)="search($event.target.value)">
                </label>
            </mat-form-field>
        </div>
    </div>

    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" style="margin-top:10px;">
        <div fxLayout="row" style="width:100%" *ngIf="!loading">
            <mat-table [dataSource]="messages" style="width: 100%; height: 300px; overflow: auto;" class="mat-elevation-z1">

                <ng-container matColumnDef="subject">
                    <mat-header-cell style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef fxLayoutAlign="start center center">Θέμα</mat-header-cell>
                    <mat-cell style="font-family: 'Century Gothic', sans-serif" *matCellDef="let message"
                              fxLayoutAlign="start center center"> {{message.subject}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="sent_date">
                    <mat-header-cell style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef fxLayoutAlign="center center center">Ημερομηνία αποστολής
                    </mat-header-cell>
                    <mat-cell style="font-family: 'Century Gothic', sans-serif"  *matCellDef="let message"
                              fxLayoutAlign="center center center"> {{message.sent_date}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="status">
                    <mat-header-cell style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef fxLayoutAlign="center center center">Κατάσταση</mat-header-cell>
                    <mat-cell  style="font-family: 'Century Gothic', sans-serif" *matCellDef="let message"
                              fxLayoutAlign="center center center"> {{message.status}} </mat-cell>
                </ng-container>


                <ng-container matColumnDef="actions">
                    <mat-header-cell  style="font-family: 'Century Gothic', sans-serif" *matHeaderCellDef fxLayoutAlign="center center center">Ενέργειες</mat-header-cell>
                    <mat-cell style="font-family: 'Century Gothic', sans-serif" *matCellDef="let message"
                              fxLayoutAlign="center center center">
                        <mat-icon (click)="preview(message.id)" class="icon" style="color: var(--primary)">remove_red_eye</mat-icon>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let record; columns: columnsToDisplay"></mat-row>
            </mat-table>
        </div>

        <div *ngIf="loading">
            <app-loading></app-loading>
        </div>

        <div *ngIf="messages.data.length === 0 && !loading">
            <div fxLayoutAlign="center center center" style="margin-top: 50px; margin-bottom: 50px;">
                Δεν έχετε μηνύματα
            </div>
        </div>

        <div fxLayout="row" fxFlex="grow" fxLayoutAlign="end end center" style="margin-top:5px;">
            <mat-paginator style="font-family: 'Century Gothic', sans-serif" [length]="messages.data.length" [pageSize]="5" [pageSizeOptions]="[5, 20, 50, 100]">
            </mat-paginator>
        </div>
    </div>
</div>
